import { Button, Card, MapView, Text } from "../../../../components";
import Localization from "../../../../localization";
import useViewModel from "../../viewModel";
import Homes from "./homes";

const Location = ({
  onEditClick = () => {},
  title = Localization.service.card_1_title,
  ...props
}) => {
  const { home } = useViewModel();
  const center = {
    lat: home?.coords?.latitude ?? 0,
    lng: home?.coords?.longitude ?? 0,
  };

  return (
    <Card title={title} {...props}>
      <MapView
        zoom={18}
        center={center}
        style={{ height: "200px" }}
        markers={[{ position: center }]}
        options={{
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          scaleControl: false,
          gestureHandling: "none",
          scrollwheel: false,
        }}
      />
      <div>
        {!!home?.address && (
          <Text
            level={4}
            weight={"700"}
            color="secondary"
            className="m-15-t"
            lineHeight="normal"
            children={home.address}
          />
        )}
        {!!home.note && (
          <Text className="m-5-t" color="secondary" children={home.note} />
        )}
        <Button
          ghost
          type="primary"
          onClick={onEditClick}
          className="m-30-t"
          title={Localization.service.card_1_btn}
        />
      </div>
    </Card>
  );
};

Location.Homes = Homes;

export default Location;
